import { useEffect } from "react";
import { toast } from "sonner";

export function usePwaUpdate() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const checkForUpdate = async () => {
      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration) return;

      // Listen for a new service worker installing
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            // New version available - show toast
            toast("Ny version tillgänglig", {
              description: "Tryck för att uppdatera appen",
              duration: Infinity,
              action: {
                label: "Uppdatera",
                onClick: () => {
                  newWorker.postMessage({ type: "SKIP_WAITING" });
                  window.location.reload();
                },
              },
            });
          }
        });
      });

      // Also check for waiting worker on load (in case update was found before this hook ran)
      if (registration.waiting && navigator.serviceWorker.controller) {
        toast("Ny version tillgänglig", {
          description: "Tryck för att uppdatera appen",
          duration: Infinity,
          action: {
            label: "Uppdatera",
            onClick: () => {
              registration.waiting?.postMessage({ type: "SKIP_WAITING" });
              window.location.reload();
            },
          },
        });
      }
    };

    // Also auto-reload when the new SW takes over
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });

    checkForUpdate();

    // Periodically check for updates (every 30 min)
    const interval = setInterval(() => {
      navigator.serviceWorker.getRegistration().then(reg => reg?.update());
    }, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);
}
